const VI_CUSTOM = {
  accessToWifi: 'Có thể truy cập Wi-Fi tại vị trí sạc.',
  AFTER_10PM_BEFORE_11AM: 'Sau 10 giờ tối; trước 11 giờ sáng',
  AFTER_11AM_BEFORE_10PM: 'Sau 11 giờ sáng; trước 10 giờ tối',
  AFTER_1230AM_BEFORE_930AM: 'Sau 12:30 sáng; trước 9:30 sáng',
  AFTER_12PM_BEFORE_8PM: 'Sau 12 giờ trưa; trước 8 giờ tối',
  AFTER_2PM_BEFORE_6PM: 'Sau 2 giờ chiều; trước 6 giờ chiều',
  AFTER_6AM_BEFORE_3PM: 'Sau 6 giờ sáng; trước 3 giờ chiều',
  AFTER_6PM_BEFORE_9AM: 'Sau 6 giờ chiều; trước 9 giờ sáng',
  AFTER_8AM_BEFORE_MN: 'Sau 8 giờ sáng; trước nửa đêm',
  AFTER_9PM_BEFORE_6AM: 'Sau 9 giờ tối; trước 6 giờ sáng',
  AFTER_9PM_BEFORE_9AM: 'Sau 9 giờ tối; trước 9 giờ sáng',
  AFTER_MN_BEFORE_8AM: 'Sau nửa đêm; trước 8 giờ sáng',
  'after.Incentives': 'SAU KHI ÁP DỤNG CÁC KHOẢN THƯỞNG',
  age: 'Tuổi',
  agreeOffPeakSchedule: 'Đồng ý tính phí theo lịch trình ngoài giờ cao điểm',
  all: 'Tất cả',
  ALL_HOURS: 'Mọi giờ giấc (không thể dự đoán trước)',
  'assumption.downPayment': 'Tiền đặt cọc',
  'assumption.downPaymentValue': '10% giá bán lẻ đề xuất + Thuế',
  'assumption.electricityRate': 'Giá điện',
  'assumption.gasolinePrice': 'Giá xăng',
  'assumption.salesTax': 'Thuế bán hàng',
  'assumption.salesTaxPercent': 'Thuế bán hàng %',
  ATTACHED_GARAGE: 'Nhà để xe liền kề',
  averageMonthlyCharge: 'CHI PHÍ TRUNG BÌNH HÀNG THÁNG',
  averageMonthlyCharge_tool:
    'Hãy chọn tổng số tiền điện phải trả (không bao gồm tiền gas) trên hóa đơn hàng tháng thông thường, bất kể mùa nào. Chúng tôi sử dụng số tiền này để ước tính mức tiêu thụ năng lượng hiện tại của bạn.',
  basement: 'Tầng hầm',
  basicFilters: 'Bộ lọc cơ bản',
  certifiedElectrician: 'thợ điện được chứng nhận',
  charger: 'BỘ SẠC',
  chargeWithLevelTwoCharger:
    'Sạc bằng bộ sạc cấp 2 đủ điều kiện hoặc lái xe điện đủ điều kiện.',
  charging: 'Đang sạc',
  'chargingMap.businessGovernment':
    'Được lắp đặt bởi doanh nghiệp hoặc chính phủ',
  'chargingMap.DCChargers': 'Sạc nhanh DC hoặc bộ sạc siêu tốc',
  'chargingMap.disclaimer':
    'Dữ liệu được cung cấp bởi Trung tâm Dữ liệu Nhiên liệu Thay thế. Bản đồ có thể không phản ánh chính xác tình trạng sẵn có mới nhất của các trạm sạc.',
  'chargingMap.errorZipcode':
    'Lỗi: {workingZipcode} không phải là mã bưu chính hợp lệ',
  'chargingMap.highPowerStations': 'Các nhà máy điện cao thế',
  'chargingMap.otherSttations': 'Các loại nhà ga khác',
  'chargingMap.privateStations': 'Trạm tư nhân',
  'chargingMap.public': 'Ga công cộng',
  'chargingMap.searchDealers': 'Tìm kiếm đại lý đủ điều kiện',
  'chargingMap.showFullListOfStations': 'DANH SÁCH ĐẦY ĐỦ CÁC TRẠM',
  'chargingMap.updateZipcode': 'Cập nhật mã bưu chính',
  chargingStations: 'Trạm sạc',
  'chargingStations.mapLegend.high': 'Các nhà máy điện cao thế',
  'chargingStations.mapLegend.highSubtext': 'Sạc nhanh DC hoặc bộ sạc siêu tốc',
  'chargingStations.mapLegend.other': 'Các loại nhà ga khác',
  'chargingStations.mapLegend.private': 'Trạm tư nhân',
  'chargingStations.mapLegend.public': 'Các ga công cộng',
  'chargingStations.mapLegend.publicSubtext':
    'Được lắp đặt bởi doanh nghiệp hoặc chính phủ',
  'chargingWizard.carOvernight': 'Bạn sẽ đậu xe ở đâu qua đêm?',
  'chargingWizard.chargingAvailability': 'khả năng sạc',
  'chargingWizard.electricianInstall':
    'Liệu thợ điện có được phép lắp đặt trạm sạc điện không?',
  'chargingWizard.noChargingAvailability': 'không có khả năng sạc',
  'chargingWizard.onTheStreet': 'Trên đường phố',
  'chargingWizard.overnightParking':
    'Bạn có thể đỗ xe qua đêm ở nơi có trạm sạc điện không?',
  'chargingWizard.parkingGarage': 'Nhà để xe riêng hoặc chỗ đậu xe',
  'chargingWizard.powerOutlet':
    'Gần chỗ bạn đậu xe có ổ cắm điện thông thường không?',
  'chargingWizard.publicParking': 'Bãi đỗ xe công cộng',
  'chargingWizard.useThisValue': 'Sử dụng giá trị này',
  'chargingWizard.youWouldHave': 'bạn sẽ có {resultText}',
  close: 'Đóng',
  compareVehicles: 'So sánh các loại xe',
  'compareVehicles.carMake': 'Hãng xe',
  'compareVehicles.carModel': 'Mô hình xe hơi',
  'compareVehicles.disclaimer': 'Không phải tất cả các hãng/mẫu xe đều có sẵn.',
  'compareVehicles.fuelType': 'Loại nhiên liệu',
  'compareVehicles.pickTwo': 'Hãy chọn ít nhất 2 chiếc xe để bắt đầu so sánh.',
  'compareVehicles.selectFuel': 'Chọn loại nhiên liệu',
  'compareVehicles.selectMake': 'Chọn hãng sản xuất',
  'compareVehicles.selectModel': 'Chọn một mẫu',
  'compareVehicles.subTitle': 'Xem tất cả các loại xe >',
  contact: 'Liên hệ',
  ContactInformation: 'Thông tin liên hệ',
  conventionalVehicleEfficiency:
    'Hiệu suất nhiên liệu của xe thông thường (mpg)',
  conventionalVehicleEfficiencyTooltip:
    'Để tính toán khoản tiết kiệm có thể đạt được, hãy nhập số dặm trên mỗi gallon (MPG) của xe chạy xăng mà bạn muốn thay thế bằng xe điện hoàn toàn hoặc xe hybrid cắm điện.',
  costOfPublicCharging: 'Chi phí thu phí công cộng',
  costOfPublicChargingTooltip:
    'Chúng tôi ước tính chi phí của các trạm sạc công cộng có thu phí, nhưng bạn có thể chỉnh sửa bộ lọc này nếu biết chi phí sạc tại địa phương mình.',
  CountiesCovered: 'Các quận/huyện được bao phủ',
  currency: '$',
  currentPricingPlan: 'BẢNG GIÁ HIỆN HÀNH',
  dealers: 'Đại lý',
  'dealers.allBrands': 'Tất cả các thương hiệu',
  'dealers.allDealers': 'Tất cả các đại lý',
  'dealers.brands': 'Thương hiệu',
  'dealers.contact': 'LIÊN HỆ',
  'dealers.findDealers': 'Tìm đại lý',
  'dealers.website': 'TRANG WEB',
  description: 'Sự miêu tả',
  DETACHED_GARAGE: 'Nhà để xe riêng biệt',
  detailedCalculations: 'Chi tiết',
  driveEVOrPHEV: 'Lái xe điện (xe điện hoàn toàn hoặc xe hybrid cắm điện)',
  DRIVEWAY: 'Không phải trong gara',
  DRParagraph1:
    'Gói giá DR tiêu chuẩn dựa trên lượng điện bạn sử dụng\n\nchứ không phải thời điểm bạn sử dụng. Bạn càng sử dụng ít điện, bạn càng trả ít tiền\n– bất kể ngày hay đêm.',
  DRParagraph2:
    'Kế hoạch này có thể phù hợp với các hộ gia đình sử dụng ít điện và những người\nthích tiết kiệm bằng cách tiết kiệm mà không cần quan tâm đến thời gian trong ngày.',
  egbBringCharger: 'Tôi sẽ sử dụng bộ sạc cấp 2 của riêng mình.',
  egbNeedCharger: 'Tôi cần bộ sạc cấp 2',
  egbOurPrograms:
    'Chúng tôi có các chương trình giúp việc sạc xe tại nhà trở nên dễ dàng hơn. Nếu bạn cần bộ sạc cấp 2, chương trình EV Accelerate At Home của chúng tôi có thể phù hợp với bạn.',
  electricians: 'Thợ điện',
  'electricians.commercial': 'Thuộc về thương mại',
  'electricians.fastEfficient':
    '{title} Thời gian cài đặt của chúng tôi được đảm bảo và đẩy nhanh để giúp bạn bắt đầu sử dụng sớm hơn.',
  'electricians.industrial': 'Công nghiệp',
  'electricians.map.caption':
    'Bạn có phải là thợ lắp đặt trạm sạc xe điện được chứng nhận tại khu vực San Diego không? Vui lòng liên hệ {email} để được xem xét đưa vào cơ sở dữ liệu thợ điện được chứng nhận của chúng tôi. Các thợ điện được liệt kê trên trang web này không được SDG&E chứng thực, tài trợ hoặc tuyển dụng.',
  'electricians.map.header': 'Lợi ích từ các đối tác ưu tiên của chúng tôi',
  'electricians.map.personalizedExperience':
    'Các chuyên gia về xe điện của chúng tôi có thể hướng dẫn bạn xuyên suốt toàn bộ quy trình.',
  'electricians.map.value': 'Chúng tôi cung cấp giá lắp đặt cạnh tranh.',
  'electricians.residential': 'Khu dân cư',
  'electricians.searchElectricians': 'Tìm kiếm thợ điện có trình độ chuyên môn',
  'electricians.subtitle':
    'Nhập mã bưu chính của bạn để tìm thợ điện được chứng nhận trong khu vực. Nhấp vào từng kết quả để xem vị trí và thông tin liên hệ.',
  'electricians.title': 'Thợ điện được chứng nhận',
  'electricians.type': 'Thợ điện',
  'electricians.worldClass':
    'Chúng tôi hợp tác với các thợ điện giàu kinh nghiệm, được kiểm tra kỹ lưỡng để đảm bảo việc lắp đặt an toàn và chuyên nghiệp.',
  electricity: 'Điện',
  electricPortion: 'Phần điện',
  electricVehicles: 'Xe điện',
  emissions: 'Khí thải',
  'Energy Information Administration': 'Cơ quan quản lý thông tin năng lượng',
  estimatedDIYCost: 'Chi phí tự làm trung bình ước tính:',
  'ev.avg.range': 'Phạm vi hoạt động trung bình bằng điện',
  'ev.carDetails.batterySizeTooltip':
    'Một kilowatt-giờ (kWh) đủ năng lượng để lái xe từ 1 đến 4 dặm, tùy thuộc vào loại xe. Pin của một máy tính xách tay thông thường chỉ có thể chứa chưa đến 0,1 kWh.',
  'ev.cardetails.calc.arborDayFoundation': 'Quỹ Ngày Trồng cây',
  'ev.carDetails.calc.charging': 'Đang sạc',
  'ev.cardetails.calc.chargingRate': 'Tốc độ sạc',
  'ev.carDetails.calc.chargingRate': 'Tốc độ sạc',
  'ev.carDetails.calc.DCFC': 'Tốc độ sạc nhanh DC (DCFC)',
  'ev.cardetails.calc.dcRate': 'Tốc độ sạc nhanh DC (DCFC)',
  'ev.cardetails.calc.description': 'Sự miêu tả',
  'ev.carDetails.calc.description': 'Sự miêu tả',
  'ev.cardetails.calc.EIA': 'Cơ quan Thông tin Năng lượng Hoa Kỳ',
  'ev.cardetails.calc.electricEmissions':
    'Lượng khí thải điện (tính bằng pound)',
  'ev.cardetails.calc.electricEmissionsLbsMwh': 'Lượng khí thải điện (lbs/mWh)',
  'ev.cardetails.calc.electricEmissionsLbsMwhMetric':
    'Lượng khí thải điện năng (kg/MWh)',
  'ev.cardetails.calc.electricEmissionsMetric': 'Lượng khí thải điện (kg)',
  'ev.cardetails.calc.electricityEmissions':
    'Lượng khí thải CO2 từ điện năng (lbs/MWh)',
  'ev.cardetails.calc.electricityEmissionsMetric':
    'Lượng khí thải CO2 từ sản xuất điện (kg/MWh)',
  'ev.carDetails.calc.electricityEmissionsMetric':
    'Lượng khí thải CO2 từ sản xuất điện (kg/MWh)',
  'ev.carDetails.calc.emissions': 'Khí thải',
  'ev.cardetails.calc.emissionsPerTree':
    'Lượng khí thải giảm được trên mỗi cây',
  'ev.cardetails.calc.emissionsReductions': 'Giảm phát thải',
  'ev.cardetails.calc.emissionsReudctions': 'Giảm phát thải',
  'ev.cardetails.calc.EPA': 'Xếp hạng hiệu quả của EPA',
  'ev.cardetails.calc.EPAMetric': 'Xếp hạng hiệu quả của NRC',
  'ev.carDetails.calc.ev.cardetails.calc.electricityEmissions':
    'Lượng khí thải CO2 từ điện năng (lbs/MWh)',
  'ev.carDetails.calc.fuel': 'Nhiên liệu',
  'ev.cardetails.calc.FuelConsumptionCa':
    'Hướng dẫn tiêu thụ nhiên liệu tại Canada',
  'ev.cardetails.calc.gallonsSaved': 'Lượng gallon đã tiết kiệm',
  'ev.cardetails.calc.gallonsSavedFormula':
    'Lượng gallon nhiên liệu tiêu thụ bởi xe chạy xăng tương đương - Lượng gallon nhiên liệu tiêu thụ bởi xe điện',
  'ev.cardetails.calc.gallonsUsed': 'Số gallon đã sử dụng',
  'ev.cardetails.calc.gallonsUsedFormula':
    'Số dặm đã đi * (1 - Phần lái xe bằng điện) / MPG',
  'ev.cardetails.calc.gasolineEmissions':
    'Lượng khí thải xăng (tính bằng pound/gallon)',
  'ev.cardetails.calc.gasolineEmissionskg': 'Lượng khí thải xăng (kg)',
  'ev.cardetails.calc.gasolineEmissionsLbs':
    'Lượng khí thải xăng (tính bằng pound)',
  'ev.cardetails.calc.gasolineEmissionsMetric': 'Lượng khí thải xăng (kg/lít)',
  'ev.cardetails.calc.gasolineEmissionsYr':
    'Lượng khí thải CO2 từ xăng (tính bằng pound/năm)',
  'ev.cardetails.calc.gasolineEmissionsYrMetric':
    'Lượng khí thải xăng (kg CO2/năm)',
  'ev.cardetails.calc.kgCo2PerYr': 'kg CO2 mỗi năm',
  'ev.cardetails.calc.kmDrivenPerYr': 'Số ki-lô-mét lái xe mỗi năm',
  'ev.carDetails.calc.kmDrivenPerYr': 'Số ki-lô-mét lái xe mỗi năm',
  'ev.carDetails.calc.kwPerKm': 'kWh trên 100 km',
  'ev.carDetails.calc.kwPerMile': 'kWh trên 100 dặm',
  'ev.cardetails.calc.lbsCo2PerYr':
    'lượng CO2 thải ra hàng năm (tính bằng pound)',
  'ev.cardetails.calc.litersSaved': 'Lượng lít tiết kiệm được',
  'ev.cardetails.calc.litersSavedFormula':
    'Lượng lít nhiên liệu tiêu thụ tương đương với xe chạy xăng - Lượng lít nhiên liệu tiêu thụ bởi xe điện',
  'ev.cardetails.calc.litersUsed': 'Lượng lít đã sử dụng',
  'ev.cardetails.calc.litersUsedFormula':
    'Số km đã đi * (1 - Phần lái xe bằng điện) * L/100 km',
  'ev.cardetails.calc.lPer100Km': 'L/100 km',
  'ev.cardetails.calc.lPerKm': 'Lít trên 100 km',
  'ev.cardetails.calc.lpkm': 'lít/kilômét',
  'ev.cardetails.calc.lvl2FullCharge': 'Thời gian sạc đầy cho cấp độ 2',
  'ev.cardetails.calc.lvlTwoChargingRate': 'Tốc độ sạc cấp 2',
  'ev.cardetails.calc.maxACIntake': 'Lượng khí nạp AC tối đa của xe',
  'ev.carDetails.calc.milesDriven': 'Số dặm lái xe mỗi năm',
  'ev.cardetails.calc.milesDrivenPerYr': 'Số dặm lái xe mỗi năm',
  'ev.cardetails.calc.milesPerGallon': 'Số dặm trên mỗi gallon (MPG)',
  'ev.carDetails.calc.milesPerGallonBasic': 'Số dặm trên mỗi gallon',
  'ev.cardetails.calc.minOflvl2AC':
    'Mức sạc tối thiểu cấp 2 và lượng khí nạp tối đa của xe',
  'ev.cardetails.calc.mpg': 'dặm/gallon',
  'ev.cardetails.calc.nationalAverageElectricityEmissions':
    'Lượng khí thải điện trung bình toàn quốc',
  'ev.cardetails.calc.portionElectric': 'Một phần của việc lái xe điện',
  'ev.cardetails.calc.portionElectricSource':
    'Dữ liệu do người dùng nhập. Đối với xe hybrid, ước tính tỷ lệ quãng đường di chuyển bằng pin điện thay vì xăng.',
  'ev.cardetails.calc.source': 'Nguồn',
  'ev.carDetails.calc.source': 'Nguồn',
  'ev.cardetails.calc.userInput': 'Đầu vào của người dùng',
  'ev.cardetails.calc.vehicleBatteryCapacity': 'Dung lượng pin xe',
  'ev.carDetails.compareText':
    'Chúng tôi đã chọn {gasVehicle} dựa trên khoảng cách gần với {vehicle} về thương hiệu, kích thước và giá cả.',
  'ev.cardetails.electricRange':
    'Để tính đến sự suy giảm hiệu năng pin, phạm vi hoạt động được nêu ở đây là ước tính dựa trên tuổi đời của xe và thói quen lái xe/sạc pin thông thường.',
  'ev.carDetails.fastChargingTooltip': 'Tốc độ sạc nhanh DC:',
  'ev.carDetails.gasolineSaved': 'Tiết kiệm xăng',
  'ev.carDetails.kilometerBatterySizeTooltip':
    'Một kilowatt-giờ (kWh) đủ năng lượng để lái xe từ 1 đến 4 dặm, tùy thuộc vào loại xe. Pin của một máy tính xách tay thông thường chỉ có thể chứa chưa đến 0,1 kWh.',
  'ev.carDetails.kilometerUsedBatterySizeTooltip':
    'Một kilowatt-giờ (kWh) đủ năng lượng để đi được từ 1 đến 4 km, tùy thuộc vào loại xe. Để tính đến sự suy giảm hiệu suất pin đối với xe điện đã qua sử dụng, dung lượng pin được nêu ở đây là ước tính dựa trên tuổi đời của xe và thói quen lái/sạc thông thường.',
  'ev.carDetails.levelTwoChargerSpeedTooltip':
    'Khi được sạc bằng bộ sạc cấp 2 công cộng hoặc tư nhân có khả năng hỗ trợ tốc độ sạc tối đa của xe. Lưu ý rằng chương trình giảm giá dành cho hộ gia đình của Consumers Energy có mức công suất tối ưu không vượt quá 240V/40A (9,6 KW) đối với các mạch sạc dân dụng.',
  'ev.carDetails.mobile':
    'Để biết thêm chi tiết, bao gồm cả biểu đồ và các phép tính {amp}, vui lòng xem trang này trên máy tính để bàn.',
  'ev.carDetails.treesPlanted': 'Cây được trồng',
  'ev.carDetails.usedBatterySizeTooltip':
    'Một kilowatt-giờ (kWh) đủ năng lượng để đi được từ 1 đến 4 dặm, tùy thuộc vào loại xe. Để tính đến sự suy giảm hiệu năng của pin đối với xe điện đã qua sử dụng, dung lượng pin được nêu ở đây là ước tính dựa trên tuổi đời của xe và thói quen lái/sạc thông thường.',
  'ev.carDetails.view': 'Xem chi tiết xe',
  'ev.cash': 'Tiền mặt',
  'ev.chargingStations.body':
    'Việc sạc pin khi đang di chuyển giờ đây dễ dàng hơn bao giờ hết. Nhập vị trí của bạn để xem tất cả các trạm sạc gần bạn.',
  'ev.compareGasVehicle':
    'So sánh {car} với một loại xe chạy bằng khí đốt tương tự, {gasCar}.',
  'ev.compareOtherVehicles': 'SO SÁNH VỚI CÁC LOẠI XE KHÁC',
  'ev.costOfPublicCharing': 'Chi phí ước tính cho việc thu phí công cộng',
  'ev.dealers.body':
    'Tìm các đại lý xe điện trong khu vực của bạn và nhấp vào từng đại lý để xem địa điểm và thông tin liên hệ.',
  'ev.electricityRateCalc':
    'Giá điện được tính theo mức giá trung bình dựa trên mức tiêu thụ điện của hộ gia đình là 700 kWh. Để tìm hiểu thêm, vui lòng nhấp vào {website}',
  'ev.electricPortion': 'Một phần của quãng đường di chuyển bằng điện',
  'ev.electricPortionTooltip':
    'Hãy ước tính tỷ lệ phần trăm quãng đường bạn lái xe hoàn toàn bằng điện. Nếu bạn sạc điện hàng ngày và lái xe ít hơn quãng đường tối đa mà chiếc xe điện bạn chọn có thể đi được chỉ bằng điện, thì tỷ lệ phần trăm này sẽ gần 100%. Nếu bạn không chắc chắn về tỷ lệ phần trăm lái xe bằng điện, hãy chọn 50%.',
  'ev.incentives.title':
    'Có thể được hưởng tối đa {savings} tiền tín dụng thuế và hoàn thuế {lineBreak} cho {car}',
  'ev.incentives.title.simple': 'Các chương trình ưu đãi và giảm giá hiện có',
  'ev.interestRate': 'Lãi suất',
  'ev.jumbotron.findADealer': 'Tìm đại lý',
  'ev.jumbotron.viewAllCars': 'Xem tất cả xe',
  'ev.kilometersDrivenAnnually': 'Số ki-lô-mét lái xe mỗi năm',
  'ev.lease': 'Cho thuê',
  'ev.loan': 'Khoản vay',
  'ev.matchScore.adjustment': 'Điều chỉnh',
  'ev.matchScore.budget': 'Ngân sách',
  'ev.matchScore.charging': 'Đang sạc',
  'ev.matchScore.maxScore': 'Điểm tối đa',
  'ev.matchScore.popover':
    'Điểm phù hợp của bạn dựa trên các tùy chọn bạn đã chọn.',
  'ev.matchScore.range': 'Phạm vi',
  'ev.matchScore.seats': 'Ghế',
  'ev.matchScore.title': 'Kết quả trận đấu',
  'ev.matchScore.totalScore': 'Tổng điểm',
  'ev.matchScore.yourScore': 'Điểm số của bạn',
  'ev.milesDrivenAnnually': 'Số dặm lái xe mỗi năm',
  'ev.planningRoute.body':
    'Việc sạc pin khi đang di chuyển giờ đây dễ dàng hơn bao giờ hết. Nhập điểm đến của bạn để xem tất cả các trạm sạc dọc đường.',
  'ev.public': 'Công cộng',
  'ev.publicPrivateCharging': 'Kết hợp sạc điện công cộng/tư nhân',
  'ev.purchaseMethod': 'Phương thức mua hàng',
  'ev.purchaseMethodToolTip':
    'Trong trường hợp thuê xe, bạn phải trả lại xe sau khi hết hạn hợp đồng. Còn trong trường hợp vay mua xe, bạn được giữ xe sau khi trả hết nợ.',
  'ev.reviews': 'Các bài đánh giá từ khắp nơi trên mạng',
  'ev.showSources.assumption': 'Giả định:',
  'ev.showSources.averageInsurancePerYear': 'Mức bảo hiểm trung bình mỗi năm',
  'ev.showSources.blendedMaintenanceCostPerKilometer':
    'Chi phí bảo trì trung bình trên mỗi kilomet',
  'ev.showSources.blendedMaintenanceCostPerKilometerSource':
    'Phần chi phí bảo dưỡng định kỳ cho xe chạy điện được tính trên mỗi kilomet đối với xe chạy xăng và xe chạy điện.',
  'ev.showSources.blendedMaintenanceCostPerMile':
    'Chi phí bảo trì trung bình trên mỗi dặm',
  'ev.showSources.blendedMaintenanceCostPerMileSource':
    'Phần chi phí lái xe điện được tính vào chi phí bảo dưỡng trên mỗi dặm đối với xe chạy xăng và xe chạy điện.',
  'ev.showSources.capitalizedCost': 'Chi phí vốn hóa',
  'ev.showSources.capitalizedCostSource':
    'Giá bán lẻ đề xuất (MSRP) - Tiền đặt cọc - Ưu đãi được tính vào vốn đầu tư',
  'ev.showSources.capitalizedIncentives': 'Ưu đãi vốn hóa',
  'ev.showSources.capitalizedIncentivesSource':
    'Các khoản ưu đãi được hạch toán vào hợp đồng thuê.',
  'ev.showSources.cashFormula':
    'Giá bán lẻ đề xuất của xe * (1 + Thuế bán hàng) - Ưu đãi - Giá trị bán lại',
  'ev.showSources.dollarPerKilometerDriven': '$/100 km đã đi',
  'ev.showSources.dollarPerKilometerDrivenPublicCharging':
    '(Chi phí ước tính của trạm sạc công cộng * Sạc kết hợp công cộng/tư nhân + Giá điện * (1 - Sạc kết hợp công cộng/tư nhân)) * Lượng kWh của xe trên 100 km',
  'ev.showSources.dollarPerKilometerDrivenSource':
    'Chi phí điện * Lượng kWh của xe trên 100 km',
  'ev.showSources.dollarPerMileDriven': '$/100 dặm lái xe',
  'ev.showSources.dollarPerMileDrivenPublicCharging':
    '(Chi phí ước tính của trạm sạc công cộng * Sạc kết hợp công cộng/tư nhân + Giá điện * (1 - Sạc kết hợp công cộng/tư nhân)) * Lượng kWh của xe trên 100 dặm',
  'ev.showSources.dollarPerMileDrivenSource':
    'Chi phí điện * Lượng kWh của xe trên 100 dặm',
  'ev.showSources.electricityRate': 'Giá điện được tính dựa trên {website}',
  'ev.showSources.EPAEfficiency': 'Xếp hạng hiệu quả của EPA',
  'ev.showSources.estimatedCostOfPublicCharging':
    'Chi phí ước tính của việc thu phí công cộng',
  'ev.showSources.firstLeasePayment': 'Khoản thanh toán thuê đầu tiên',
  'ev.showSources.firstLeasePaymentSource':
    'Tiền đặt cọc + Tiền thuê hàng tháng',
  'ev.showSources.gasolineCost': 'Giá xăng',
  'ev.showSources.insurancePerYear': 'Bảo hiểm hàng năm',
  'ev.showSources.insurancePerYearSource':
    'Dự đoán chi phí bảo hiểm trung bình tại {state}, dựa trên giá bán lẻ đề xuất của xe so với giá bán lẻ đề xuất trung bình của {msrp}',
  'ev.showSources.insuranceSource': 'Chi phí bảo hiểm trung bình tại',
  'ev.showSources.kilometerVehicleKWh':
    'Mức tiêu thụ điện năng (kWh) của xe trên 100 km',
  'ev.showSources.leaseForumla':
    'Khoản thanh toán thuê đầu tiên + (Số tháng sở hữu - 1) * (Khoản thanh toán thuê hàng tháng) - Ưu đãi thuê không được vốn hóa',
  'ev.showSources.lifetimeKilometers': 'Số kilomet đã đi trong suốt vòng đời',
  'ev.showSources.lifetimeMiles': 'Dặm tích lũy trọn đời',
  'ev.showSources.loanAmount': 'Số tiền vay',
  'ev.showSources.loanFormula':
    'Giá bán lẻ đề xuất (MSRP) * (1 + Thuế bán hàng) - Tiền đặt cọc',
  'ev.showSources.maintenanceCostReduction': 'Giảm chi phí bảo trì xe điện',
  'ev.showSources.maintenanceCostReductionSource': '{website}',
  'ev.showSources.maintenancePerKilometer':
    'Chi phí bảo dưỡng trên mỗi km đối với xăng',
  'ev.showSources.maintenancePerKilometerElectricity':
    'Chi phí bảo trì điện theo từng kilomet',
  'ev.showSources.maintenancePerKilometerElectricitySource':
    'Chi phí bảo dưỡng trên mỗi km đối với xe chạy xăng * Hệ số giảm chi phí bảo dưỡng xe điện',
  'ev.showSources.maintenancePerMile': 'Chi phí bảo dưỡng theo dặm cho xăng',
  'ev.showSources.maintenancePerMileElectricity':
    'Chi phí bảo trì điện theo từng dặm',
  'ev.showSources.maintenancePerMileElectricitySource':
    'Chi phí bảo dưỡng trên mỗi dặm đối với xe chạy xăng * Hệ số giảm chi phí bảo dưỡng xe điện',
  'ev.showSources.maintenancePerMileSource':
    'Dự toán chi phí bảo trì trung bình của {avgMaintenanceCost}, dựa trên giá bán lẻ đề xuất của xe so với giá bán lẻ đề xuất trung bình của {averageMSRP}',
  'ev.showSources.mixPublicPrivateCharging':
    'Kết hợp sạc điện công cộng/tư nhân',
  'ev.showSources.moneyFactor': 'Yếu tố tiền tệ',
  'ev.showSources.moneyFactorSource':
    'Tương đương với dữ liệu người dùng nhập vào là {interestRateAsBasisPoints}',
  'ev.showSources.monthlyDepreciationCost': 'Chi phí khấu hao hàng tháng',
  'ev.showSources.monthlyDepreciationCostSource':
    '(Chi phí vốn hóa - Giá trị bán lại) / Số tháng sở hữu',
  'ev.showSources.monthlyFinancingCost': 'Chi phí tài chính hàng tháng',
  'ev.showSources.monthlyFinancingCostSource':
    '(Giá trị vốn hóa + Giá trị bán lại) * Hệ số tiền tệ',
  'ev.showSources.monthlyLeasePayment': 'Thanh toán thuê hàng tháng',
  'ev.showSources.monthlyLeasePaymentSource':
    '(Chi phí khấu hao hàng tháng + Chi phí tài chính hàng tháng) * (1 + Thuế bán hàng)',
  'ev.showSources.monthlyPayments': 'Thanh toán hàng tháng',
  'ev.showSources.monthlyPaymentsSource':
    'Chức năng tài chính của số tiền vay, lãi suất và số tháng sở hữu',
  'ev.showSources.monthsOfOwnership': 'Số tháng sở hữu',
  'ev.showSources.nonCapLeaseIncentives': 'Ưu đãi thuê không vốn hóa',
  'ev.showSources.nonCapLeaseIncentivesSource':
    'Các khoản ưu đãi không được tính vào chi phí thuê vốn hóa',
  'ev.showSources.portionElectricSource':
    'Dữ liệu do người dùng nhập. Đối với xe hybrid, ước tính tỷ lệ quãng đường di chuyển bằng pin điện thay vì xăng.',
  'ev.showSources.portionElectricSourceKilometer':
    'Dữ liệu do người dùng nhập. Đối với xe hybrid, ước tính tỷ lệ quãng đường di chuyển bằng pin điện thay vì xăng.',
  'ev.showSources.resaleValue': 'Giá trị bán lại',
  'ev.showSources.resaleValueSource':
    '{carName}: e^(ln({resaleFactor})/36000*{lifetimeMiles})*MSRP',
  'ev.showSources.totalElectricityCost': 'Tổng chi phí điện',
  'ev.showSources.totalElectricityCostSource':
    '$/100 dặm đã đi * Số dặm trọn đời * {portionEVDriving}/ 100',
  'ev.showSources.totalGasolineCost': 'Tổng chi phí xăng dầu',
  'ev.showSources.totalGasolineCostSource':
    'Chi phí xăng * Số dặm đã đi trọn đời * {portionEVDriving}/ MPG',
  'ev.showSources.totalInsuranceCost': 'Tổng chi phí bảo hiểm',
  'ev.showSources.totalInsuranceCostSource':
    'Chi phí bảo hiểm hàng năm * Số năm sở hữu',
  'ev.showSources.totalKilometerElectricityCostSource':
    '$/100 km đã đi * Số km đã đi trọn đời * {portionEVDriving}/ 100',
  'ev.showSources.totalKilometerGasolineCostSource':
    'Chi phí xăng * Số km đã đi trọn đời * {portionEVDriving}/ lPerKm',
  'ev.showSources.totalKilometerMaintenanceCostSource':
    'Chi phí bảo trì trên mỗi km * Số km đã đi trong suốt vòng đời sản phẩm',
  'ev.showSources.totalLoanFormula':
    'Tiền đặt cọc + Tổng số tiền trả hàng tháng - Ưu đãi - Giá trị bán lại',
  'ev.showSources.totalMaintenanceCost': 'Tổng chi phí bảo trì',
  'ev.showSources.totalMaintenanceCostSource':
    'Chi phí bảo trì trên mỗi dặm * Số dặm trọn đời',
  'ev.showSources.totalMonthlyPayments': 'Tổng số tiền thanh toán hàng tháng',
  'ev.showSources.totalMonthlyPaymentsSource':
    'Số tiền thanh toán hàng tháng * Số tháng sở hữu',
  'ev.showSources.totalVehicleCost': 'Tổng chi phí xe',
  'ev.showSources.vehicleKWh':
    'Mức tiêu thụ điện năng (kWh) của xe trên 100 dặm',
  'ev.showSources.vehiclelPerKm': 'Mức tiêu hao nhiên liệu của xe (LP/Km)',
  'ev.showSources.vehicleMPG':
    'Mức tiêu hao nhiên liệu của xe (dặm trên gallon)',
  'ev.showSources.yearsOfOwnership': 'Số năm sở hữu',
  'ev.used.electricRange': 'Phạm vi hoạt động trung bình bằng điện',
  'ev.used.yearRange': 'Khoảng thời gian',
  'ev.usedCarTitle': 'Đã sử dụng {car}',
  'ev.yearsOwnership': 'Số năm sở hữu/thuê',
  'evCard.electricRange': 'Bếp điện',
  'evCard.matchScore': 'TỶ SỐ TRẬN ĐẤU',
  'evCard.seeDetails': 'Xem chi tiết',
  'evCard.seeElectricVehicle': 'XEM XE ĐIỆN',
  'evCard.totalRange': 'Tổng phạm vi',
  'eventCard.hostedBy': 'Được tổ chức bởi',
  'eventCard.inPerson': 'Sự kiện trực tiếp',
  'eventCard.inPersonAndVirtual': 'Sự kiện trực tiếp + Sự kiện trực tuyến',
  'eventCard.learnMore': 'Tìm hiểu thêm',
  'eventCard.virtualEvent': 'Sự kiện ảo',
  'eventCatalog.noEvents':
    'Không tìm thấy sự kiện nào phù hợp với tiêu chí tìm kiếm hiện tại của bạn. Hãy thử thay đổi tiêu chí tìm kiếm.',
  'eventCatalog.noMatch': 'Chúng tôi không tìm thấy kết quả phù hợp nào.',
  events: 'Sự kiện',
  'events.allLocations': 'Tất cả các địa điểm',
  'events.autoshow': 'Triển lãm ô tô',
  'events.both': 'Trực tiếp và Trực tuyến',
  'events.conference': 'Hội nghị',
  'events.distance': 'Khoảng cách',
  'events.educationEvent': 'Sự kiện giáo dục',
  'events.inPerson': 'Trực tiếp',
  'events.inPersonOrVirtual': 'Trực tiếp hoặc Trực tuyến',
  'events.nationwide': 'Toàn quốc',
  'events.nationWide': 'Toàn quốc',
  'events.rideAndDrive': 'Lái thử',
  'events.subHeader':
    'Hãy đến xem, chạm và cảm nhận xe điện trực tiếp tại một sự kiện sắp tới.',
  'events.training': 'Đào tạo',
  'events.virtual': 'Ảo',
  'events.webinar': 'Hội thảo trực tuyến',
  eventsDateRange: 'Khoảng thời gian',
  eventsFilters: 'Bộ lọc',
  'eventSort.dateLtH': 'Ngày (Sớm nhất trước)',
  evfilter: 'Bộ lọc',
  'evfilter.carTitle': 'Ưu tiên xe điện',
  'evfilter.fuel': 'Nhiên liệu',
  'evfilter.fuelTooltip':
    'Xe điện hoàn toàn chỉ sử dụng điện. Xe hybrid cắm điện có thể sử dụng cả điện và xăng.',
  'evfilter.type': 'Kiểu',
  evFuelType: 'Hoàn toàn bằng điện',
  'evs.budgetAfterIncentives': 'Ngân sách sau khi trừ các khoản khuyến khích',
  'evs.buttonMatchScoreAndFilters': 'Điểm số trận đấu và các bộ lọc',
  'evs.chargercard.chargingtime.na': 'NA',
  'evs.chargerCatalog.noChargers': 'Không tìm thấy bộ sạc nào.',
  'evs.chargingAvailability': 'Khả năng sạc',
  'evs.disclaimer':
    'Các xe được hiển thị có thể không phản ánh tình trạng thực tế. Chúng tôi không xác nhận hoặc khuyến nghị bất kỳ loại xe hoặc nhà sản xuất ô tô cụ thể nào.',
  'evs.graph.compare':
    'So sánh các xe điện theo phạm vi hoạt động hoặc giá cả. Di chuột vào xe điện để xem thêm chi tiết.',
  'evs.graph.disclaimer':
    'Các xe được hiển thị có thể không phản ánh tình trạng thực tế. {companyName} không xác nhận hoặc khuyến nghị bất kỳ loại xe hoặc nhà sản xuất ô tô cụ thể nào.',
  'evs.graph.mobile':
    'Để xem biểu đồ Phạm vi hoạt động so với Chi phí, vui lòng xem trang này trên máy tính để bàn.',
  'evs.graph.rangeVsCost': 'Phạm vi hoạt động so với chi phí',
  'evs.graph.tiles': 'Gạch lát xe',
  'evs.graph.title': 'Xe điện',
  'evs.helpMeChoose': 'Giúp tôi lựa chọn',
  'evs.highPower.legend': 'Các nhà máy điện cao thế',
  'evs.homeChargingAvailability': 'Khả năng sạc tại nhà',
  'evs.homeChargingAvailabilityTooltip':
    'Xe điện sẽ tiện lợi hơn nhiều nếu bạn có thể sạc nhanh tại nhà.',
  'evs.incentivesScoreOptions': 'Bộ lọc điều kiện nhận ưu đãi',
  'evs.levelOne': 'Cấp độ 1',
  'evs.levelTwo': 'Cấp độ 2',
  'evs.matchScoreAndFilters': 'Tinh chỉnh điểm số phù hợp và bộ lọc',
  'evs.matchScoreOptions': 'Bộ lọc',
  'evs.minSeats': 'Số ghế tối thiểu',
  'evs.noCharging': 'Không sạc',
  'evs.other.legend': 'Các loại nhà ga khác',
  'evs.public.legend': 'Các ga công cộng',
  'evs.roundTripCommute': 'Số dặm trung bình mỗi ngày',
  'evs.seats': 'chỗ ngồi',
  'evs.slideMilesDrivenDaily': 'Phạm vi tối thiểu',
  'evs.thirdParty':
    '*Trang web này chứa các liên kết đến các trang web bên ngoài của bên thứ ba. SDGE không xác nhận hoặc chịu bất kỳ trách nhiệm nào đối với nội dung hoặc sản phẩm được bán trên bất kỳ trang web bên thứ ba nào. Xin lưu ý rằng xe này có thể không có sẵn tại khu vực của bạn. Vui lòng liên hệ với đại lý địa phương để đảm bảo tình trạng còn hàng.',
  'evs.welcomeSub':
    'Tùy chỉnh tìm kiếm để khám phá các loại xe điện phù hợp với nhu cầu của bạn.',
  'evs.welcomeSubMobile':
    'Tùy chỉnh tìm kiếm để khám phá các loại xe điện phù hợp với nhu cầu của bạn.',
  'evSort.alphabetical': 'Theo thứ tự bảng chữ cái',
  'evSort.chargerPower': 'Công suất bộ sạc',
  'evSort.electricRange': 'Bếp điện',
  'evSort.matchScore': 'Tỷ số trận đấu',
  'evSort.priceHtL': 'Giá: Từ cao đến thấp',
  'evSort.priceLtH': 'Giá: Từ thấp đến cao',
  'evSort.title': 'SẮP XẾP THEO',
  FAQ: 'Câu hỏi thường gặp',
  feet: 'bàn chân',
  filing_status_tooltip: 'Được sử dụng để xác định điều kiện nhận ưu đãi.',
  fuel_tooltip: 'Chọn tất cả các kiểu dáng xe mà bạn quan tâm.',
  Finished: 'Hoàn thành',
  'footer.allRights': 'Bản quyền đã được bảo lưu.',
  'footer.chargingStations': '{chargingStations}',
  'footer.compareVehicles': '{compareVehicles}',
  'footer.copyright':
    '© 1998-2026 Công ty Khí đốt và Điện lực San Diego. Các nhãn hiệu được sử dụng trong tài liệu này là tài sản của các chủ sở hữu tương ứng. Mọi quyền được bảo lưu.',
  'footer.disclaimer':
    'Công ty {COMPANY_NAME}® là công ty con của Sempra®. SDG&E® và San Diego Gas & Electric là các nhãn hiệu đã được đăng ký của Công ty San Diego Gas & Electric.',
  'footer.electricVehicles': '{electricVehicles}',
  'footer.homeChargers': '{homeChargers}',
  'footer.incentives': '{incentives}',
  'footer.jdpDisclaimer':
    'Các số liệu hiển thị trên trang này là ước tính dựa trên dữ liệu do bên thứ ba cung cấp. Tài liệu này chỉ được cung cấp cho mục đích thông tin và không nên được sử dụng làm cơ sở cho tư vấn thuế, pháp lý hoặc tài chính. Cả J.D. Power® và SDGE đều không cung cấp tư vấn thuế, pháp lý hoặc tài chính. Bạn nên tự mình xác minh các ước tính được cung cấp ở đây trước khi tham gia bất kỳ giao dịch nào.',
  'footer.poweredBy': 'Được hỗ trợ bởi Zappyride',
  'footer.ratepayerDisclaimer':
    'Các thông báo trên trang web này được tài trợ bởi người đóng thuế, trừ khi có ghi chú khác.',
  'footer.zappyDisclaimer':
    'Các số liệu hiển thị trên trang này là ước tính dựa trên dữ liệu do bên thứ ba cung cấp. Tài liệu này chỉ được cung cấp cho mục đích thông tin và không nên được sử dụng làm cơ sở cho tư vấn thuế, pháp lý hoặc tài chính. Cả J.D. Power® và SDGE đều không cung cấp tư vấn thuế, pháp lý hoặc tài chính. Bạn nên tự mình xác minh các ước tính được cung cấp ở đây trước khi tham gia bất kỳ giao dịch nào.',
  'footer.zappyDisclaimer.one':
    'Giải pháp xe điện © 2026 J.D. Power, được cung cấp với sự cho phép.',
  footerPhrase1: 'Mức giá và Quy định',
  footerPhrase10: 'Tổng giá điện',
  footerPhrase11: 'Lựa chọn của khách hàng',
  footerPhrase2: 'Yêu cầu dữ liệu năng lượng',
  footerPhrase3: 'Điều khoản và điều kiện',
  footerPhrase4: 'Tiêu chuẩn ứng xử của FERC - Lệnh 717',
  footerPhrase5: 'Các dự án chính',
  footerPhrase6: 'Dịch vụ khách hàng',
  footerPhrase7: 'Thông báo của CPUC',
  footerPhrase8: 'Nghề nghiệp',
  footerPhrase9: 'Trung tâm bảo mật',
  forInstallation: 'để lắp đặt',
  forLevelTwoCharger: 'dành cho bộ sạc cấp 2',
  forSeparateMeter: 'cho đồng hồ đo riêng',
  free: 'Miễn phí',
  ft: 'ft',
  galperyear: 'gallon/năm',
  garage: 'Ga-ra',
  gasoline: 'Xăng',
  gasolinePrice: 'Giá xăng',
  gasolinePriceInCentsPerGal_tooltip:
    'Nhập giá xăng tại khu vực của bạn. Giá mặc định của chúng tôi dựa trên giá xăng mới nhất tại khu vực của bạn, được cập nhật hàng tháng.',
  'graph.assumptions': 'Các giả định',
  'graph.cheaper': 'rẻ hơn',
  'graph.costDifferent': 'Tại sao giá lại khác nhau?',
  'graph.costOfOwnership.chart.electricity': 'Điện',
  'graph.costOfOwnership.chart.gasoline': 'Xăng',
  'graph.costOfOwnership.chart.insurance': 'Bảo hiểm',
  'graph.costOfOwnership.chart.maintenance': 'BẢO TRÌ',
  'graph.costOfOwnership.chart.vehicle': 'Ưu đãi ròng cho xe, giá bán lại',
  'graph.costOfOwnership.description': 'Sự miêu tả',
  'graph.costOfOwnership.descriptionRow.electricity': 'Điện',
  'graph.costOfOwnership.descriptionRow.gasoline': 'Xăng',
  'graph.costOfOwnership.descriptionRow.insurance': 'Bảo hiểm',
  'graph.costOfOwnership.descriptionRow.maintenance': 'BẢO TRÌ',
  'graph.costOfOwnership.descriptionRow.vehicle': 'Phương tiện giao thông',
  'graph.costOfOwnership.subTitle':
    '{carName} là {style} {costDeltaText} {costDeltaTextEnding}',
  'graph.costOfOwnership.subTitleThreeCars':
    'Mẫu {carName} là mẫu có chi phí sở hữu thấp nhất trong vòng {yearsOfOwnership} năm.',
  'graph.costOfOwnership.title': 'Chi phí sở hữu',
  'graph.costOfOwnership.totalRow': 'Tổng cộng',
  'graph.costToBreakdown': 'Chi phí sửa chữa',
  'graph.costToBreakdown.note':
    'Lưu ý: Biểu đồ điểm hòa vốn giả định rằng các phương tiện được mua bằng tiền mặt.',
  'graph.costToBreakdown.subTitle':
    'So sánh tổng chi phí trọn đời của {car1} với {car2}',
  'graph.costToBreakdown.subTitleThreeCars':
    'So sánh tổng chi phí trọn đời của {car1}, {car2} và {car3}',
  'graph.costVsRange.afterIncentives':
    'Từ {price} sau khi trừ đi các khoản khuyến khích',
  'graph.costVsRange.electricKilometerRange':
    'Phạm vi hoạt động bằng điện: {kilometers} km',
  'graph.costVsRange.electricRange': 'Phạm vi hoạt động bằng điện: {miles} dặm',
  'graph.electricRange.assumption': 'Phạm vi dựa trên ước tính của EPA',
  'graph.electricRange.assumptions': 'Các giả định',
  'graph.electricRange.description': 'Sự miêu tả',
  'graph.electricRange.electricity': 'Điện',
  'graph.electricRange.gasoline': 'Xăng',
  'graph.electricRange.gasolineRange': 'Phạm vi xăng',
  'graph.electricRange.subTitle':
    'Phạm vi hoạt động bằng điện của {car} là {costDeltaText} x {number} dặm',
  'graph.electricRange.subTitleThreeCars':
    'Mẫu {car} có phạm vi hoạt động bằng điện dài nhất.',
  'graph.electricRange.total': 'Tổng cộng',
  'graph.fuelRange.chart.chargedHome': 'sạc tại nhà',
  'graph.fuelRange.chart.description': 'Sự miêu tả',
  'graph.fuelRange.chart.fuelBudget': 'ngân sách nhiên liệu',
  'graph.fuelRange.chart.howFar':
    'Bạn có thể lái chiếc {car} được bao xa với mức tiêu hao nhiên liệu {budget}?',
  'graph.fuelRange.chart.kilometers': 'kilômét',
  'graph.fuelRange.chart.miles': 'dặm',
  'graph.fuelRange.chart.network': 'trên mạng Plug-In Everywhere',
  'graph.fuelRange.chart.rangeOn': 'Phạm vi trên',
  'graph.fuelRange.chart.similarGas': 'một chiếc xe chạy bằng xăng tương tự',
  'graph.fuelRange.chart.unlimited': 'Không giới hạn',
  'graph.graphValues': 'giá trị đồ thị',
  'graph.hide': 'Trốn ',
  'graph.monthlyCostToFill.subTitle':
    '{carName} là {style} {costDeltaText} để điền hàng tháng',
  'graph.monthlyCostToFill.subTitleThreeCars':
    'Loại {carName} là loại rẻ nhất để đổ đầy hàng tháng.',
  'graph.monthlyCostToFill.title': 'Chi phí đổ đầy hàng tháng',
  'graph.moreExpensive': 'đắt hơn',
  'graph.show': 'Trình diễn ',
  'graph.showCostBreakdown': 'Hiển thị chi tiết chi phí',
  'graph.similarGasVehicle': 'Xe chạy bằng xăng tương tự',
  'graph.speedOfCharge.fastChargerTitle':
    'Lượng điện năng sạc được mỗi 30 phút sạc nhanh.',
  'graph.speedOfCharge.fastChargingSpeed': 'Tốc độ sạc nhanh',
  'graph.speedOfCharge.kilometersLevelTwoChargerThreeCars':
    'Sạc được quãng đường tối đa với bộ sạc cấp 2.',
  'graph.speedOfCharge.kilometersThirtyFastChargeThreeCars':
    'Sạc được quãng đường tối đa trong 30 phút sạc nhanh.',
  'graph.speedOfCharge.kmLevelTwoCharger': 'km/giờ với bộ sạc cấp 2',
  'graph.speedOfCharge.kmThirtyFastCharge':
    'số km đi được sau 30 phút sạc nhanh',
  'graph.speedOfCharge.levelTwoChargingSpeed': 'Tốc độ sạc cấp 2',
  'graph.speedOfCharge.mphLevelTwoCharger': 'dặm trên giờ với bộ sạc cấp 2',
  'graph.speedOfCharge.mphLevelTwoChargerThreeCars':
    'Sạc được quãng đường tối đa mỗi giờ với bộ sạc cấp 2',
  'graph.speedOfCharge.mphLevelTwoChargerTitle':
    'Lượng phí mỗi giờ khi sạc ở cấp độ 2',
  'graph.speedOfCharge.subTitle':
    'Các điện tích {car} sạc {number} {costDeltaText} {subTitleText}',
  'graph.speedOfCharge.subTitleThreeCars': '{car} {subTitleText}',
  'graph.speedOfCharge.thirtyFastCharge':
    'số dặm đi được sau mỗi 30 phút sạc nhanh',
  'graph.speedOfCharge.thirtyFastChargeThreeCars':
    'Sạc được quãng đường xa nhất trong 30 phút sạc nhanh.',
  'graph.title.costAnalysis': 'Phân tích chi phí',
  'graph.title.electricRange': 'Bếp điện',
  'graph.title.miles': 'Dặm',
  'graph.title.speedOfCharge': 'Tốc độ sạc',
  'graph.title.totalRange': 'Tổng phạm vi',
  'graph.toOwnOver': 'sở hữu hơn',
  'graph.year': ' Năm',
  'graph.years': 'Năm',
  'graph.yourEV': 'Lựa chọn xe điện của bạn',
  hcaCarCondition: 'TÌNH TRẠNG XE',
  hcaCarMake: 'Hãng xe',
  hcaCarModel: 'Mô hình xe hơi',
  hcaChargerLocation: 'Vị trí trạm sạc',
  hcaCurrentElectricRate: 'Giá điện hiện tại',
  hcaCurrentMonthlyBill: 'Hóa đơn hàng tháng hiện tại',
  hcaDistanceSliderLabel: 'Khoảng cách: Từ tấm pin đến vị trí sạc',
  hcaDistanceSliderLabelToolTip:
    'Hãy lưu ý rằng các mạch điện thường không chạy theo đường thẳng giữa bảng điều khiển và vị trí sạc do có tường, sàn nhà hoặc không gian ngoài trời ở giữa.',
  hcaElectricPanelLocation: 'Vị trí bảng điện',
  hcaIncludedEnergyCosts: 'CHI PHÍ NĂNG LƯỢNG ĐÃ BAO GỒM',
  hcaNewestModels: 'Các mẫu mới nhất',
  hcaOlderModels: 'Các mẫu cũ hơn',
  hcaPanelLocationRoomType: 'Vị trí bảng điều khiển Loại phòng',
  hcaPortionPublicCharging: 'Một phần của phí công cộng',
  hcaPortionPublicChargingTooltip:
    'Người lái xe điện hầu hết đều sạc pin tại nhà.',
  hcaPublicChargingCost: 'Chi phí sạc điện công cộng',
  hcaWhenWillYouCharge: 'Khi nào bạn sẽ tính phí?',
  'header.cards.electricians': 'Tìm thợ điện được chứng nhận',
  'header.cards.home-chargers': 'Mua bộ sạc tại nhà',
  'header.cards.incentives': 'Các ưu đãi tìm kiếm',
  'header.cards.rates': 'Xem công cụ tính toán tiết kiệm',
  'header.chargingStations': 'Trạm sạc',
  'header.compareVehicles': 'So sánh các loại xe',
  'header.electricians': 'Thợ điện',
  'header.electricVehicles': 'Xe điện',
  'header.electricVehicles.v2': 'Khám phá xe điện',
  'header.home': 'Trang chủ',
  'header.homeChargers': 'Bộ sạc nhà',
  'header.incentives': 'Các biện pháp khuyến khích',
  'header.newVehicles': 'Khám phá các lựa chọn xe điện',
  'header.promise.cta': 'Hãy bắt đầu bằng các biện pháp khuyến khích.',
  'header.promise.subtitle':
    'Ước tính và so sánh chi phí, khoản tiết kiệm, ưu đãi và nhiều hơn nữa liên quan đến xe điện.',
  'header.promise.title': 'Tận dụng tối đa chiếc xe điện của bạn.',
  'header.rates': 'Máy tính tiết kiệm',
  'header.usedVehicles': 'Khám phá các lựa chọn xe điện',
  here: 'đây',
  high: 'Cao',
  home: 'Trang chủ',
  'home.vehicleCarousel.browseAllEvs': 'Xem tất cả xe điện',
  'home.vehicleCarousel.compareEvs': 'So sánh xe điện',
  'home.vehicleCarouselSubTitle':
    'Hãy so sánh lựa chọn của bạn với một chiếc xe chạy xăng tương tự. Xe điện có thể giúp bạn tiết kiệm tiền vì chi phí sở hữu và bảo trì có thể rẻ hơn so với xe chạy hoàn toàn bằng xăng.',
  'home.vehicleCarouselTitle':
    'Hiện nay có nhiều xe điện hơn bao giờ hết. Hãy tìm chiếc xe điện phù hợp với bạn.',
  homechargerChargerType: 'LOẠI BỘ SẠC',
  homechargerEvfilter: 'Bộ lọc cơ bản',
  homeChargers: 'Bộ sạc nhà',
  'homeChargers.cable': 'Cáp {length} ft.',
  'homechargers.caption':
    'Các bộ sạc tại nhà được liệt kê trên trang web này không do SDG&E sản xuất hoặc chứng thực.',
  'homeChargers.cordLength': 'Chiều dài dây',
  'homeChargers.cordLengthHtL': 'Chiều dài dây: Từ cao đến thấp',
  'homeChargers.cordLengthLtH': 'Chiều dài dây: Từ thấp đến cao',
  'homeChargers.disclaimer':
    'Các nhà sản xuất bộ sạc, muốn sản phẩm của mình được giới thiệu tại đây? Hãy liên hệ với {email}.',
  'homeChargers.hardwired': 'Kết nối dây cứng',
  'homeChargers.meterCable': 'Cáp {length} m',
  'homeChargers.portable': 'Cầm tay',
  'homeChargers.price': 'Giá',
  'homeChargers.selectMake': 'Chọn hãng sản xuất',
  'homeChargers.selectModel': 'Chọn một mẫu',
  'homeChargers.socket': 'Ổ cắm',
  'homeChargers.socketTooltip':
    'Bộ sạc xe điện tại nhà có nhiều kiểu phích cắm khác nhau. Các kiểu phích cắm này tương ứng với cách các chấu cắm khớp với ổ cắm trên tường nhà bạn. Nếu bạn không chắc chắn ổ cắm nào phù hợp nhất với nhà hoặc gara của mình, hãy tham khảo ý kiến của thợ điện có chứng nhận.',
  'homeChargers.subText':
    'Chọn loại xe bạn quan tâm để xem thời gian sạc cụ thể cho đến khi đầy pin.',
  'homeChargers.subtitle':
    'Tìm các tùy chọn trạm sạc xe điện cấp 2 phù hợp với nhu cầu nhà ở và sở thích xe điện của bạn. Điều chỉnh bộ lọc để cá nhân hóa kết quả.',
  'homeChargers.title': 'Bộ sạc nhà',
  'homeChargers.toFullCharge': 'sạc đầy',
  'homeChargers.wallMounted': 'Đã lắp đặt',
  'homeChargers.wifi': 'Kết nối WiFi',
  'homeChargersCard.beforeIncentives': 'Trước khi có các khoản khuyến khích',
  'homeChargersCard.buy': 'Xem chi tiết',
  'homeChargersCard.socket': 'Ổ cắm {socket}',
  'homeChargersCard.teslaWarning': 'Bộ sạc này chỉ tương thích với xe Tesla.',
  'homepage.incentives.exporeIncentives':
    'KHÁM PHÁ CÁC CHƯƠNG TRÌNH KHUYẾN KHÍCH',
  'homepage.incentives.subTitle':
    'Hãy xem bạn có thể tiết kiệm được bao nhiêu khi lái xe điện, dù là mua hay thuê. {lineBreak} Các ưu đãi được cá nhân hóa dựa trên khu vực bạn sinh sống.',
  'homepage.incentives.title':
    'Tìm hiểu các ưu đãi và khoản giảm thuế tiềm năng dành cho xe điện.',
  'homepage.linkCard.browseElectricVehicles':
    'DUYỆT CÁC LOẠI XE ĐIỆN {lineBreak}',
  'homepage.linkCard.discoverIncentives': 'KHÁM PHÁ CÁC ƯU ĐÃI {lineBreak}',
  'homepage.linkCard.findDealers': 'Tìm đại lý {lineBreak}',
  'homepage.linkCard.homeChargers': 'TRANG CHỦ {lineBreak} BỘ SẠC',
  'homepage.linkCard.locateChargingStations': 'TÌM CÁC TRẠM SẠC {lineBreak}',
  'homepage.vehicleCarousel.findEVButton': 'Xem tất cả các phương tiện',
  'homepage.vehicleCarousel.subTitle':
    'Hãy chọn một chiếc xe điện và so sánh chi phí với một chiếc xe chạy xăng tương tự. Xe điện có thể giúp bạn tiết kiệm tiền vì chúng thường rẻ hơn khi sở hữu và bảo trì so với đối thủ chạy hoàn toàn bằng xăng.',
  'homepage.vehicleCarousel.title':
    'Hiện có {vehicleCount} xe điện đang được bán. Hãy tìm chiếc xe phù hợp với bạn.',
  'homepage.welcome': 'Colton đã được sạc đầy',
  'homepage.welcomeSub':
    'Cẩm nang xe điện dành cho bạn, được cung cấp bởi Công ty Điện lực Colton. Ước tính và so sánh chi phí, khoản tiết kiệm, ưu đãi dành cho xe điện và nhiều hơn nữa.',
  'homepage.zipcode.disclaimer':
    'Bảng giá cá nhân hóa chỉ trong chưa đầy 1 phút. Không cần đăng ký.',
  'homepage.zipcode.getStarted': 'Bắt đầu',
  'homepage.zipcode.subtitle':
    'Công cụ này sẽ giúp xác định rõ ràng gói giá xe điện có chi phí thấp nhất.',
  'homepage.zipcode.title':
    'Bạn có biết chúng tôi cung cấp nhiều gói giá xe điện khác nhau? Hãy tìm gói giá xe điện phù hợp nhất với bạn.',
  homeWiring: 'HỆ THỐNG ĐIỆN GIA ĐÌNH',
  incentives: 'Các biện pháp khuyến khích',
  'incentives.clunkerNone':
    'Một số chương trình ưu đãi sẽ bù đắp cho bạn khi loại bỏ chiếc xe cũ, hay còn gọi là xe "cục gạch".',
  'incentives.clunkertoolTip':
    'Một số chương trình ưu đãi sẽ bồi thường cho bạn khi loại bỏ chiếc xe cũ, hay còn gọi là xe "cục gạch". Cụ thể,',
  'incentives.clunkertoolTipContd':
    'Các chương trình này hiện có sẵn tại khu vực của bạn. Điều kiện tham gia khác nhau tùy theo từng chương trình; vui lòng kiểm tra chi tiết chương trình.',
  household_income_tooltip:
    'Kết hợp thu nhập của tất cả các thành viên trong hộ gia đình. Được sử dụng để xác định điều kiện nhận ưu đãi.',
  household_size_tooltip:
    'Được sử dụng để xác định điều kiện nhận ưu đãi. Bao gồm tất cả các thành viên trong hộ gia đình của bạn (vợ/chồng, người phụ thuộc, v.v.). Rất ít hoặc không có ưu đãi nào đề cập đến hộ gia đình có hơn 8 thành viên, vì vậy hãy chọn 8 nếu hộ gia đình của bạn có từ 8 thành viên trở lên.',
  'incentives.electricityProvider': 'Nhà cung cấp điện',
  'incentives.headOfHousehold': 'Chủ hộ',
  'incentives.householdIncome': 'Thu nhập hộ gia đình',
  'incentives.householdIncomeTooltip':
    'Dùng để xác định điều kiện nhận ưu đãi. Bao gồm tất cả các thành viên trong hộ gia đình của bạn (vợ/chồng, người phụ thuộc, v.v.). Rất ít hoặc không có ưu đãi nào đề cập đến hộ gia đình có hơn 8 thành viên, vì vậy hãy chọn 8 nếu quy mô hộ gia đình của bạn từ 8 người trở lên.',
  'incentives.householdSize': 'Quy mô hộ gia đình',
  'incentives.householdSizeTooltip':
    'Bao gồm tất cả các thành viên trong hộ gia đình của bạn (vợ/chồng, người phụ thuộc, v.v.). Được sử dụng để xác định điều kiện được hưởng ưu đãi.',
  'incentives.incentiveEligibility': 'Cập nhật điều kiện hưởng ưu đãi',
  'incentives.income': 'Thu nhập và tình trạng thuế',
  'incentives.incomeTooltip':
    'Điều kiện nhận ưu đãi và số tiền bạn có thể nhận thường phụ thuộc vào thu nhập của bạn. Khách hàng có thu nhập thấp hơn thường đủ điều kiện nhận được khoản hoàn tiền cao hơn.',
  'incentives.less': ' ít hơn',
  'incentives.location': 'Vị trí',
  'incentives.locationTooltip':
    'Nhiều ưu đãi phụ thuộc vào nơi bạn sinh sống. Hãy nhập mã bưu chính của bạn để giúp xác định những ưu đãi nào có sẵn tại khu vực bạn đang sống.',
  'incentives.married': 'Đã cưới',
  'incentives.more': '... hơn',
  'incentives.planClunker': 'Bạn định đổi chiếc xe cũ nát của mình à?',
  'incentives.retiringVehicleTooltip':
    'Việc loại bỏ xe chạy xăng cũ có thể là điều kiện bắt buộc để được hưởng một số ưu đãi nhất định.',
  'incentives.selectModel': 'Chọn mẫu',
  'incentives.selectTrim': 'Chọn Trim',
  'incentives.single': 'Đơn',
  'incentives.subTitle':
    'Bạn có thể đủ điều kiện nhận các ưu đãi giúp giảm chi phí mua hoặc thuê xe điện. Điều chỉnh bộ lọc để cá nhân hóa kết quả và nhấp vào từng ô để tìm hiểu thêm.',
  'incentives.taxFilingStatus': 'Tình trạng kê khai thuế',
  'incentives.taxFilingStatusTooltip':
    'Dùng để xác định điều kiện được hưởng ưu đãi.',
  'incentives.title': 'Chính sách ưu đãi cho xe điện',
  'incentives.tradeIn': 'Bạn đang muốn thanh lý một chiếc xe?',
  'incentives.vehicleType': 'Loại xe',
  'incentives.vehicleTypeTooltip':
    'Một số ưu đãi phụ thuộc vào loại xe bạn mua.',
  'incentives.whichVehicle': 'Bạn dự định mua loại xe nào?',
  'incentiveSort.aToZ': 'Theo thứ tự bảng chữ cái: A đến Z',
  'incentiveSort.largest': 'Lớn nhất đầu tiên',
  'incentiveSort.zToA': 'Theo thứ tự bảng chữ cái: Từ Z đến A',
  'input-zipcode-for-rate-comp-launch':
    'Dùng để xác định điều kiện nhận ưu đãi. Bao gồm tất cả các thành viên trong hộ gia đình của bạn (vợ/chồng, người phụ thuộc, v.v.). Rất ít hoặc không có ưu đãi nào đề cập đến hộ gia đình có hơn 8 thành viên, vì vậy hãy chọn 8 nếu quy mô hộ gia đình của bạn từ 8 người trở lên.',
  install: 'CÀI ĐẶT',
  kgperyear: 'kg/năm',
  kilometersShort: 'km',
  lbsperyear: 'pound/năm',
  linkUnavailable: 'Kết nối mạng không khả dụng',
  literperyear: 'L/năm',
  liveInResidenceState:
    'Sống tại một địa chỉ được cung cấp điện bởi Xcel Energy ở {stateName}',
  loading: 'Đang tải',
  low: 'Thấp',
  m: 'm',
  make: 'Làm',
  maps: 'Bản đồ',
  'matchScore.adjustment': 'Điều chỉnh',
  'matchScore.budget': 'Ngân sách',
  'matchScore.charging': 'Đang sạc',
  'matchScore.maxScore': 'Điểm tối đa',
  'matchScore.popover':
    'Điểm phù hợp của bạn dựa trên các tùy chọn bạn đã chọn.',
  'matchScore.range': 'Phạm vi',
  'matchScore.seats': 'Ghế',
  'matchScore.title': 'Kết quả trận đấu',
  'matchScore.totalScore': 'Tổng điểm',
  'matchScore.yourScore': 'Điểm số của bạn',
  medium: 'Trung bình',
  'miles-driven-annually-range_tooltip':
    'Dựa trên ước tính của Bộ Giao thông Vận tải về số dặm trung bình hàng năm được lái vào năm 2020, một tài xế thông thường đi khoảng 16.000 dặm mỗi năm.',
  milesDrivenAnnually_tooltip: 'Theo Bộ Giao thông vận tải',
  milesWord: 'Dặm',
  modal1:
    'Mức phí điện trung bình trên hóa đơn hàng tháng của bạn là bao nhiêu?',
  modal10: 'Lời khuyên: Một tài xế thông thường đi khoảng 12.000 dặm mỗi năm.',
  modal11: 'Khoảng thời gian sạc nào phù hợp nhất với bạn?',
  modal12:
    'Mẹo: Sạc vào ban đêm (từ 12 giờ đêm đến 6 giờ sáng) là tiết kiệm chi phí nhất. Bạn có thể lập trình xe điện của mình để sạc vào khung giờ phù hợp nhất với bạn.',
  modal13: 'Mọi giờ',
  modal14: 'Gói giá hiện tại của bạn là gì?',
  modal15: 'Mẹo: Hầu hết khách hàng đang sử dụng gói cước TOU-DR1.',
  modal16:
    'Lưu ý: Đối với khách hàng sử dụng các gói giá không dành cho xe điện (bao gồm DR, TOU-DR1 và DR-SES), chúng tôi giả định rằng bạn hiện đang lái một xe chạy xăng có loại, nhãn hiệu và giá tương tự như xe điện đã chọn ở Bước 2 và hiển thị khoản tiết kiệm khi chuyển sang sử dụng xe điện này. Đối với khách hàng sử dụng gói giá EV-TOU-5, chúng tôi giả định rằng bạn đã sở hữu xe điện đã chọn và hiển thị khoản tiết kiệm hiện tại của bạn so với các gói giá không dành cho xe điện.',
  modal2: 'Bước chân',
  modal3: 'của',
  modal4: 'Kế tiếp',
  modal5: 'Bạn hiện đang sở hữu hoặc muốn mua/thuê xe điện nào?',
  modal6: 'Mẹo: Bạn có thể điều chỉnh các bộ lọc này sau khi xem kết quả.',
  modal7:
    'Hãy chọn xe điện hiện tại hoặc xe điện bạn ưa thích để xem mức tiết kiệm tiềm năng với các gói giá khác nhau. Việc lựa chọn xe sẽ ảnh hưởng đến mức tiết kiệm hóa đơn tiền điện do sự khác biệt về hiệu suất và hiệu quả điện giữa các mẫu xe.',
  modal8: 'TRƯỚC',
  modal9: 'Trung bình mỗi năm bạn lái xe bao nhiêu dặm?',
  model: 'Người mẫu',
  'model.year': 'Năm sản xuất',
  month: 'tháng',
  monthWord: 'tháng',
  new: 'Mới',
  newVehicles: 'Xe mới',
  no: 'KHÔNG',
  overTenYears: 'HƠN 10 NĂM',
  pages: 'Trang',
  personalizeIncentives: 'Cá nhân hóa các chương trình khuyến khích',
  phevFuelType: 'Xe hybrid cắm điện',
  portionOfPublicCharging: 'Một phần của phí công cộng',
  portionOfPublicChargingTooltip:
    'Nếu bạn không thể sạc tại nhà, bạn sẽ cần sạc tại các trạm sạc công cộng có thu phí. Hãy ước tính xem bao nhiêu phần trăm thời gian sạc xe điện sẽ được thực hiện tại các trạm sạc công cộng có thu phí thay vì sạc tại nhà.',
  'pre-owned': 'Đã qua sử dụng',
  Preferredpartner: 'Đối tác ưu tiên',
  prefferedEvChargingTimeframe: 'THỜI GIAN SẠC XE ĐIỆN ƯU TIÊN',
  prefferedEvChargingTimeframe_tooltip:
    'Sạc vào ban đêm (12 giờ đêm - 6 giờ sáng) là tiết kiệm chi phí nhất. Bạn có thể lập trình cho xe điện của mình sạc vào khung giờ phù hợp nhất với bạn.',
  prefferedEvMake: 'HÃNG XE ĐIỆN ƯU TIÊN',
  prefferedEvMake_tooltip:
    'Lưu ý: Chúng tôi giả định rằng hiện tại bạn đang lái một chiếc xe chạy xăng có kiểu dáng, nhãn hiệu và giá cả tương tự như chiếc xe điện bạn đã chọn.',
  prefferedEvModel: 'Mẫu xe điện được ưa chuộng',
  'pricePanels.cash': 'Tiền mặt',
  'pricePanels.downPayment': 'Tiền đặt cọc',
  'pricePanels.downPaymentDescription': '10% giá bán lẻ đề xuất cộng thuế',
  'pricePanels.firstLeasePayment': 'KHOẢN THANH TOÁN THUÊ ĐẦU TIÊN',
  'pricePanels.incentivesForLease': 'Ưu đãi cho thuê',
  'pricePanels.lease': 'Cho thuê',
  'pricePanels.leasePayment': 'Thanh toán tiền thuê',
  'pricePanels.loan': 'Khoản vay',
  'pricePanels.loanPayment': 'Thanh toán khoản vay',
  'pricePanels.perMonth': ' / tháng',
  'pricePanels.seeAllCosts': 'Xem tất cả chi phí',
  'pricePanels.seeAllIncentives': 'Xem tất cả các ưu đãi',
  'rateAdvisor.caption':
    'Công cụ Tính toán Tiết kiệm này chỉ mang tính chất minh họa. Đây không phải là lời hứa hay đảm bảo rằng chi phí sạc thực tế của bạn sẽ bằng với chi phí hiển thị trong công cụ. SDG&E không đảm bảo tính chính xác, đầy đủ hoặc hữu ích của thông tin chi phí ước tính. SDG&E từ chối mọi trách nhiệm đối với bất kỳ thiệt hại nào phát sinh liên quan đến việc sử dụng công cụ Tính toán Tiết kiệm. Chi phí sạc thực tế của bạn sẽ thay đổi dựa trên một số yếu tố. “SDG&E” đề cập đến Công ty Khí đốt và Điện lực San Diego. ©2022 SDG&E. Bảo lưu mọi quyền.',
  'rateAdvisor.pricingPlanComparison': 'So sánh các gói giá',
  'rateAdvisor.sub':
    'Xác định các cơ hội tiết kiệm của bạn với xe điện. Điều chỉnh bộ lọc để xem các khoản tiết kiệm của bạn.',
  'rateAdvisor.title': 'Máy tính tiết kiệm',
  'rateComparison.youAreAlreadySaving':
    'Bạn đã tiết kiệm được tới {highlightText} nếu bạn sở hữu xe điện và sử dụng gói cước {highlight}.',
  'rateComparison.youAreAlreadySavingVehicle':
    'Bạn đã tiết kiệm được tới {highlightText} mỗi năm với {highlight} bằng {selectedVehicle}.',
  'rateComparison.youAreSaving':
    'Bạn sẽ tiết kiệm được tới {highlightText} nếu bạn sở hữu xe điện và sử dụng gói cước {highlight}.',
  'rateComparison.youAreSavingVehicle':
    'Bạn có thể tiết kiệm {highlightText} mỗi năm trên {highlight} với {selectedVehicle}.',
  rateDRSESParagraph1:
    'DR-SES là gói cước dành cho khách hàng sử dụng năng lượng mặt trời và các nguồn năng lượng tái tạo khác.\n\nGiá cả được tính dựa trên thời gian và ngày trong tuần, cùng với lượng điện bạn sử dụng.\nBạn',
  rateDRSESParagraph2:
    'Kế hoạch này có thể phù hợp với bạn nếu bạn sản xuất năng lượng tái tạo,\nnếu bạn có thể chuyển các hoạt động sử dụng năng lượng của mình sang trước 4 giờ chiều và sau 9 giờ tối,\nvà nếu bạn có thể tận dụng giá điện thấp hơn trong\nthời gian ngoài giờ cao điểm.',
  rateEVTOU5Paragraph1:
    'Gói EV-TOU-5 dành cho khách hàng sạc xe điện tại nhà.\n\nGiá cả được tính dựa trên lượng điện bạn sử dụng và thời điểm sử dụng, với ba\nkhoảng thời gian tính giá. Đổi lại một khoản phí dịch vụ cơ bản, chúng tôi cung cấp\nmức giá thấp nhất cho việc sạc xe điện qua đêm tại nhà.',
  rateEVTOU5Paragraph2:
    'Kế hoạch này có thể phù hợp nếu bạn có thể chuyển một phần lượng điện sử dụng của mình ra khỏi giờ cao điểm từ 4-9 giờ chiều và bạn có thể thường xuyên sạc\nxe điện trong thời gian siêu thấp điểm vào đêm khuya.',
  rateTOUDR1Paragraph1:
    'Giá điện TOU-DR1 dựa trên lượng điện bạn sử dụng, cũng như\nthời gian và ngày trong tuần bạn sử dụng. Với ba khung giờ tính giá,\nbạn có cơ hội tiết kiệm nhiều nhất vào ban đêm và cuối tuần.',
  rateTOUDR1Paragraph2:
    'Kế hoạch này có thể phù hợp nếu bạn có thể chuyển một phần lượng điện sử dụng của mình ra khỏi\ngiờ cao điểm từ 4-9 giờ chiều và bạn có thể tận dụng\ngiá điện thấp hơn trong thời gian ngoài giờ cao điểm vào ban đêm và\ncuối tuần.',
  regularResidential: 'Cư dân thường trú',
  'results.updated': 'Kết quả đã được cập nhật vào lúc...',
  saved: 'đã lưu',
  'select-charger-level_tooltip':
    'Nhiều xe điện sẽ thuận tiện hơn cho bạn nếu bạn có thể sạc nhanh tại nhà.',
  savingsGraphDisclaimer:
    '* Giả định rằng bạn đang sử dụng gói giá này để cấp điện cho nhà mình và hiện đang lái một chiếc xe chạy xăng có kiểu dáng, nhãn hiệu và giá cả tương tự với xe điện mà bạn đã chọn.',
  savingsGraphEVLabel: 'Xe điện',
  savingsGraphGasLabel: 'Xăng',
  savingsGraphHomeLabel: 'Trang chủ',
  savingsGraphYAxis: 'Chi phí trung bình ước tính mỗi năm',
  source: 'Nguồn',
  sources: 'nguồn',
  'tabbed-maps-all-stations-tab': 'Trạm sạc',
  'tabbed-maps-dealer-catalog-tab': 'Đại lý',
  'tabbed-maps-electricians-tab': 'Thợ điện',
  'tabbed-maps-route-tab': 'Lập bản đồ tuyến đường',
  total: 'Tổng cộng',
  trade_in_tooltip:
    'Việc loại bỏ một chiếc xe chạy bằng xăng cũ có thể là yêu cầu bắt buộc đối với một số ưu đãi.',
  trim: 'Cắt tỉa',
  type_tooltip:
    'Xe thuần điện chỉ sử dụng điện. Xe hybrid cắm điện có thể sử dụng cả điện và xăng.',
  Unfinished: 'Chưa xong',
  updateZipcode: 'Cập nhật mã bưu chính',
  usedElectricVehicles: 'Xe điện đã qua sử dụng',
  'vehicle.afterIncentives': 'SAU KHI ÁP DỤNG CÁC KHOẢN THƯỞNG',
  'vehicle.age.four': 'Trên 4 tuổi',
  'vehicle.age.one': '0-1 tuổi',
  'vehicle.age.two': '2-3 tuổi',
  'vehicle.allElectric': 'Hoàn toàn bằng điện',
  'vehicle.batterySize': 'KÍCH THƯỚC PIN',
  'vehicle.bev': 'Điện',
  'vehicle.coTwoEmissions': 'GIẢM PHÁT THẢI CO2',
  'vehicle.electricRange': 'BẾP ĐIỆN',
  'vehicle.estimatedIncentives': 'ƯỚC TÍNH CÁC KHOẢN KHUYẾN KHÍCH',
  'vehicle.fewer': 'ít hơn',
  'vehicle.fuelType': 'LOẠI NHIÊN LIỆU',
  'vehicle.gas': 'Xăng',
  'vehicle.gasoline.metricPrice': 'Giá xăng ($/L)',
  'vehicle.gasoline.price': 'Giá xăng ($/gallon)',
  'vehicle.greater': 'lớn hơn',
  'vehicle.kilometers': 'kilômét',
  'vehicle.kilometersCapital': 'Kilômét',
  'vehicle.kilometersPerThirtyFastCharge':
    'Số km đi được sau 30 phút sạc nhanh',
  'vehicle.kilometersShort': 'km',
  'vehicle.miles': 'dặm',
  'vehicle.milesCapital': 'Dặm',
  'vehicle.milesCaptital': 'Dặm',
  'vehicle.milesPerThirtyFastCharge':
    'QUÃNG ĐƯỜNG ĐI ĐƯỢC SAU 30 PHÚT SẠC NHANH',
  'vehicle.milesShort': 'mi',
  'vehicle.more': 'hơn',
  'vehicle.msrp': 'Giá bán lẻ đề xuất (MSRP)',
  'vehicle.phev': 'Điện và xăng',
  'vehicle.plugInHybrid': 'Xe hybrid cắm điện',
  'vehicle.status': 'Tình trạng xe',
  'vehicle.timeToChargeLvlTwo': 'THỜI GIAN SẠC - CẤP ĐỘ 2',
  'vehicle.trees': 'cây cối',
  'vehicle.type': 'KIỂU',
  'vehicle.type.coupe': 'Xe coupe',
  'vehicle.type.crossover': 'Xe crossover',
  'vehicle.type.hatchback': 'Xe hatchback',
  'vehicle.type.minivan': 'Xe minivan',
  'vehicle.type.sedan': 'Sedan',
  'vehicle.type.suv': 'SUV',
  'vehicle.type.truck': 'Xe tải',
  'vehicle.type.wagon': 'Xe ngựa',
  'vehicle.view': 'Xem',
  vehicles: 'Xe cộ',
  'vehicles.new': 'Mới',
  'vehicles.none': 'Không tìm thấy phương tiện nào',
  'incentives.noneFound':
    'Không có ưu đãi nào khớp với bộ lọc hiện tại của bạn. Hãy thử mở rộng bộ lọc xe hoặc điều kiện đủ điều kiện.',
  'vehicles.used': 'Đã sử dụng',
  vehicleType: 'Chọn tất cả các loại thân xe mà bạn quan tâm.',
  viewSavings: 'XEM KHOẢN TIẾT KIỆM',
  Website: 'Trang web',
  yes: 'Đúng',
  youAreEligible: 'Bạn',
  zipcode: 'MÃ BƯU CHÍNH',
  zipCode: 'Mã bưu chính',
};

export default VI_CUSTOM;
